export default {

  // fn: immediately return a shell promise
  shellPromise (response) {
    // build a shell promise
    const SHELL_PROMISE = new Promise((resolve, reject) => {
      return resolve(response)
    })

    // return the shell promise
    return SHELL_PROMISE
  }
}



// WEBPACK FOOTER //
// ./src/services/$glUtil.js